import request2 from '@/utils/request2'
import { BUSINESS_BASE_URL } from '@/api/baseUrl'

/**
 * 获取数据
 * @param {*} params
 */
export function get(params) {
  return request2({
    url: BUSINESS_BASE_URL() + '/mdm/mdmMember/' + params,
    method: 'get'
  })
}
